import React from 'react';
import styled from 'styled-components';

import NumbersWidget from './NumbersWidget';
import ImageWidget from './ImageWidget';
import BookMeetingLinkWidget from './BookMeetingLinkWidget';
import CoursesWidget from './CoursesWidget';
import TeachersWidget from './TeachersWidget';

const WidgetList = styled.ul`
    @media(max-width: 767px) {
        width:100%;
    }
`

export default props => {
    const { widgets, page } = props;
    const pageBackground = page && page.acf && page.acf.page_background ? page.acf.page_background : 'white';

    if (!widgets) {
        return null;
    }

    return (
        <WidgetList>
            {widgets.map((widget, i) => {
                if (widget.acf_fc_layout === 'numbers') {
                    return <NumbersWidget key={i} data={widget.numbers} pageBackground={pageBackground} />
                }

                if (widget.acf_fc_layout === 'image') {
                    return <ImageWidget key={i} data={widget.image} />
                }

                if (widget.acf_fc_layout === 'book_meeting_link') {
                    return <BookMeetingLinkWidget key={i} data={widget.image} />
                }

                if (widget.acf_fc_layout === 'products') {
                    return <CoursesWidget key={i} data={widget.items} pageBackground={pageBackground} title={widget.widget_title} />
                }

                if (widget.acf_fc_layout === 'employees') {
                    return <TeachersWidget key={i} data={widget.employee} pageBackground={pageBackground} />
                }

                return null;
            })}
        </WidgetList>
    );
}



// WEBPACK FOOTER //
// ./src/partials/modules/RichText/Widgets.js